import LoadingBox from "../decorations/LoadingBox";

const FormFieldLoadingPlaceholder = () => {
	return (
		<div className="flex flex-col gap-2">
			<LoadingBox className="h-4 w-52" />
			<LoadingBox className="h-10 rounded-md" />
		</div>
	);
};

export default FormFieldLoadingPlaceholder;
